import { render, staticRenderFns } from "./save-attributions-modal.vue?vue&type=template&id=4e148320&"
import script from "./save-attributions-modal.ts?vue&type=script&lang=js&"
export * from "./save-attributions-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports